import React, {useEffect, useState} from 'react';
import usePixelRatio from "./usePixelRatio";
import PropTypes from "prop-types";

const UseImageSrc = (imgSrc) => {
  const [src, setSrc] = useState(null);
  const pixelRatio = usePixelRatio();
  useEffect(() => {

    if (pixelRatio > 1) {

      if (imgSrc) {
        const divided = imgSrc.split(".");

        setSrc(divided[0] + "--4x" + "." + divided[1]);
      }
    } else {
      setSrc(imgSrc);
    }
  }, [pixelRatio])

  return src;
};

UseImageSrc.defaultProps = {
  imgSrc: null
}

UseImageSrc.propTypes = {
  imgSrc: PropTypes.string
}

export default UseImageSrc;